/**
 * 测试
 */
let env = ''
if (/env=dev/.test(window.location.href)) {
  env = 'dev'
} else if (/env=bae/.test(window.location.href)) {
  env = 'bae'
} else if (/env=pre2/.test(window.location.href)) {
  env = 'pre2'
} else if (/env=pre/.test(window.location.href)) {
  env = 'pre'
} else if (/env=pre1/.test(window.location.href)) {
  env = 'pre1'
} else if (/env=apitest/.test(window.location.href)) {
  env = 'apitest'
} else if (/env=lff/.test(window.location.href)) {
  env = 'lff'
} else if (/env=test/.test(window.location.href)) {
  env = 'test'
} else if (/env=hmm/.test(window.location.href)) {
  env = 'hmm'
} else if (/env=pre2w/.test(window.location.href)) {
  env = 'pre2w'
} else if (/env=lxc/.test(window.location.href)) {
  env = 'lxc'
} else if (/env=wg/.test(window.location.href)) {
  env = 'wg'
} else if (/env=ll/.test(window.location.href)) {
  env = 'll'
} else if (/env=hjq/.test(window.location.href)) {
  env = 'hjq'
} else if (/env=mayue/.test(window.location.href)) {
  env = 'mayue'
} else {
  env = 'online' // 默认环境
}
const SERVER_URL = {
  online: {
    // 正式环境
    SERVER_URL1: 'https://mapi.licaimofang.com',
    SERVER_URL2: 'https://passport.licaimofang.com',
    SERVER_URL3: 'https://trade.licaimofang.com',
    SERVER_URL4: 'https://kapi-web.licaimofang.com'
  },
  bae: {
    // 第一版本 测试环境
    SERVER_URL1: 'http://bae.hpc.mofanglicai.com.cn',
    SERVER_URL2: 'http://bae.passport.hpc.mofanglicai.com.cn',
    // SERVER_URL3: 'http://bae.mapi.hpc.mofanglicai.com.cn'
    SERVER_URL4: 'http://kapi-web.bae.mofanglicai.com.cn:10080'
  },
  pre: {
    // 第二版本 测试环境1
    SERVER_URL1: 'https://mapipre.licaimofang.com',
    SERVER_URL2: 'https://passportpre.licaimofang.com',
    SERVER_URL3: 'https://tradepre.licaimofang.com'
  },
  dev: {
    // 第二版本 测试环境2
    SERVER_URL1: 'http://luzhi.hpc.mofanglicai.com.cn',
    SERVER_URL2: 'http://bae.passport.hpc.mofanglicai.com.cn',
    SERVER_URL3: 'http://luzhi.trade.hpc.mofanglicai.com.cn',
    SERVER_URL4: 'http://kapi-web.bae.mofanglicai.com.cn:10080'
  },
  test: {
    SERVER_URL1: 'http://mapi7.yitao.mofanglicai.com.cn:10080',
    SERVER_URL2: 'http://kapi-passport.yitao.mofanglicai.com.cn:10080',
    SERVER_URL4: 'http://kapi-web.yitao.mofanglicai.com.cn:10080'
  },
  lff: {
    SERVER_URL1: 'http://mapi.lifangfang.mofanglicai.com.cn:10080',
    // SERVER_URL2: 'https://passport.licaimofang.com',
    SERVER_URL2: 'http://passport.bae.mofanglicai.com.cn:10080'
  },
  pre1: {
    SERVER_URL1: 'https://mapi-kp1.licaimofang.com',
    SERVER_URL2: 'https://passport-kp1.licaimofang.com',
    SERVER_URL4: 'https://kapi-web-kp1.licaimofang.com'
    // cms: "http://anycms.licaimofang.com",
    // update: "http://zhangliang.m.mofanglicai.com.cn/app-update/public",
    // trade: "https://trade-pre2.licaimofang.com"
  },
  pre2: {
    SERVER_URL1: 'https://mapi-kp2.licaimofang.com',
    SERVER_URL2: 'https://passport-kp2.licaimofang.com',
    SERVER_URL4: 'https://kapi-web-kp2.licaimofang.com'
    // cms: "http://anycms.licaimofang.com",
    // update: "http://zhangliang.m.mofanglicai.com.cn/app-update/public",
    // trade: "https://trade-pre2.licaimofang.com"
  },
  // test: {
  //   SERVER_URL1: "http://bae.mapi.test.hpc.mofanglicai.com.cn:8103",
  //   SERVER_URL2: "http://yitao.kapi-passport.hpc.mofanglicai.com.cn:8097",
  //   // cms: "http://anycms.mofanglicai.com",
  //   // update: "http://zhangliang.update.hpc.mofanglicai.com.cn/public",
  //   // trade: "http://bae.trade.test.hpc.mofanglicai.com.cn:8103"
  // },
  hmm: {
    SERVER_URL1: 'http://mapi.hmm.mofanglicai.com.cn:10081'
  },
  pre2w: {
    SERVER_URL1: 'https://mapi-pre2w.licaimofang.com',
    SERVER_URL2: 'https://passport-pre2w.licaimofang.com'
    // cms: "http://anycms.licaimofang.com",
    // update: "http://zhangliang.m.mofanglicai.com.cn/app-update/public",
    // trade: "https://trade-pre2.licaimofang.com"
  },
  lxc: {
    SERVER_URL1: 'http://mapi.lengxiaochu.mofanglicai.com.cn:10080',
    SERVER_URL2: 'http://passport.bae.mofanglicai.com.cn:10080'
  },
  wg: {
    SERVER_URL1: 'http://mapi.wanggang.mofanglicai.com.cn:10080/',
    SERVER_URL2: 'http://passport.wanggang.mofanglicai.com.cn:10080/'
    // cms: "http://anycms.licaimofang.com",
    // update: "http://zhangliang.m.mofanglicai.com.cn/app-update/public",
    // trade: "https://trade-pre2.licaimofang.com"
  },
  ll: {
    SERVER_URL1: 'http://mapi.ll.mofanglicai.com.cn:10080/',
    SERVER_URL2: 'http://passport.ll.mofanglicai.com.cn:10080/'
    // cms: "http://anycms.licaimofang.com",
    // update: "http://zhangliang.m.mofanglicai.com.cn/app-update/public",
    // trade: "https://trade-pre2.licaimofang.com"
  },
  hjq: {
    SERVER_URL1: 'http://mapi.huangjianquan.mofanglicai.com.cn:10080/',
    SERVER_URL2: 'http://passport.huangjianquan.mofanglicai.com.cn:10080/'
    // cms: "http://anycms.licaimofang.com",
    // update: "http://zhangliang.m.mofanglicai.com.cn/app-update/public",
    // trade: "https://trade-pre2.licaimofang.com"
  },
  mayue: {
    SERVER_URL4: 'http://kapiweb.mayue.mofanglicai.com.cn:10080'
  }
}
export default SERVER_URL[env]



// WEBPACK FOOTER //
// ./src/services/config.js